<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <div>
      <h6
        class="
          tx-uppercase tx-10 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("transfer.条件筛选") }}
      </h6>
      <div>
        <div class="mg-b-10 form-group">
          <select-distributor
            class="mg-b-10"
            :noLike="true"
            :key_word="keyDistributorName"
            @changeKeyword="changeName"
            @keywordEnter="filtrateName"
            @keywordFilter="filtrateNameDefault"
          />
        </div>
        <div class="form-group mg-b-10">
          <input
            v-model="transferCode"
            type="text"
            :placeholder="$t('transfer.转运单号')"
            class="form-control form-control-dark tx-13"
          />
        </div>
        <div class="form-group mg-b-10">
          <input
            v-model="trackCode"
            type="text"
            :placeholder="$t('transfer.物流单号')"
            class="form-control form-control-dark tx-13"
          />
        </div>
        <div class="form-group mg-b-10 d-flex align-items-center">
          <input
            style="width: 45%"
            class="form-control form-control-dark form-control-sm"
            :placeholder="$t('transfer.起始包裹重')"
            v-model="weightGeq"
            v-INT
          />
          <span class="mg-x-5"> ~ </span>
          <input
            style="width: 45%"
            class="form-control form-control-dark form-control-sm"
            :placeholder="$t('transfer.截止包裹重')"
            v-model="weightLeq"
            v-INT
          />
        </div>
        <div class="form-group mg-b-10">
          <select
            class="form-control form-control-dark pd-y-0"
            v-model="keyStatus"
            @change="filtrate"
          >
            <option value="">{{ $t("transfer.请选择状态") }}</option>
            <option
              v-for="(status, k) in $dict.transferAboardStatus"
              :key="k"
              :value="k"
            >
              {{ $t(status) }}
            </option>
          </select>
        </div>
        <div class="form-group mg-b-10">
          <select
            class="form-control form-control-dark pd-y-0"
            v-model="keyLogistics"
            @change="filtrate"
          >
            <option value="">{{ $t("transfer.请选择物流") }}</option>
            <option
              v-for="item in _tracks"
              :key="item.id"
              :value="item.logistics"
            >
              {{ item.logistics }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="
        btn btn-primary btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
      @click="filtrate"
    >
      {{ $t("transfer.筛 选") }}
    </button>
  </div>
</template>

<script>
import SelectDistributor from "@components/supplier/select-distributor-2.vue"; //客户搜索
export default {
  props: [
    "status",
    "_status",
    "track_code",
    "weight_geq",
    "weight_leq",
    "transfer_code",
    "distributor_name",
    "logistics",
    "_tracks",
  ],
  data() {
    return {
      keyDistributorName: "",
      keyDistributorId: "",
      keyDistributorName1: "",
      keyDistributorId1: "",
      keyStatus: "",
      weightGeq: "",
      weightLeq: "",
      trackCode: "",
      transferCode: "",
      keyLogistics: "",
    };
  },
  components: {
    "select-distributor": SelectDistributor,
  },
  watch: {
    logistics() {
      this.keyLogistics = this.logistics;
    },
    _status() {
      this.keyStatus = this._status;
    },
    track_code() {
      this.trackCode = this.track_code;
    },
    weight_geq() {
      this.weightGeq = this.weight_geq;
    },
    weight_leq() {
      this.weightLeq = this.weight_leq;
    },
    transfer_code() {
      this.transferCode = this.transfer_code;
    },
    distributor_name() {
      this.keyDistributorName = this.distributor_name;
      this.keyDistributorName1 = this.distributor_name;
    },
  },
  methods: {
    changeName(name, id) {
      this.keyDistributorName = name;
      this.keyDistributorId = id;
      //    if (name != this.distributor_name) this.keyDistributorId = "";
    },
    filtrateName(name, id) {
      if (name && name == this.distributor_name) {
        this.filtrate();
        return;
      }
      if (!id || id == "e999") {
        if (id == "e999")
          ShowTip(this.$t("transfer.没有匹配的供应商"), "danger");
        this.keyDistributorName = "";
        this.keyDistributorId = "";
      } else {
        //清空按供应商名
        this.keyDistributorName = name;
        this.keyDistributorId = id;
      }
      this.filtrate();
    },
    filtrateNameDefault(name, id) {
      this.keyDistributorName1 = name;
      this.keyDistributorId1 = id;
    },
    filtrate() {
      if (!this.keyDistributorId) {
        this.keyDistributorName = "";
        this.keyDistributorId = this.keyDistributorId1;
        this.keyDistributorName = this.keyDistributorName1;
        this.$emit(
          "filtrate",
          this.keyStatus,
          this.keyDistributorName1,
          this.keyDistributorId1,
          this.weightGeq,
          this.weightLeq,
          this.trackCode,
          this.transferCode,
          this.keyLogistics
        );
      } else {
        if (!this.keyDistributorId1) {
          this.$emit(
            "filtrate",
            this.keyStatus,
            this.keyDistributorName,
            this.keyDistributorId,
            this.weightGeq,
            this.weightLeq,
            this.trackCode,
            this.transferCode,
            this.keyLogistics
          );
        } else {
          this.keyDistributorName = "";
          this.keyDistributorId = this.keyDistributorId1;
          this.keyDistributorName = this.keyDistributorName1;
          this.$emit(
            "filtrate",
            this.keyStatus,
            this.keyDistributorName1,
            this.keyDistributorId1,
            this.weightGeq,
            this.weightLeq,
            this.trackCode,
            this.transferCode,
            this.keyLogistics
          );
        }
      }
    },
  },
  mounted() {
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  updated() {
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
};
</script>
